import { useTranslation } from 'react-i18next';
import React from 'react';
import {Box, Typography, Button} from '@mui/material';
import { Fragment } from 'react';
function ErrorLoginPage() {
  const { t } = useTranslation();
  return(
    <Fragment>
      <Box p={2}>
        <Typography variant="h5" color="error">{t("Verbindung konnte nicht hergestellt werden")}</Typography>
      </Box>
      <Box p={2}>
        <Typography variant="body1">{t("Um die App zu verwenden, benötigen Sie eine aktive Internetverbindung.")}</Typography>
        <Typography variant="body1">{t("Bitte prüfen Sie ob eine aktive Internetverbindung besteht.")}</Typography>
      </Box>
      <Box p={2}>
        <Button variant="contained" color="primary" onClick={() => window.location.reload()}>{t("Erneut versuchen")}</Button>
      </Box>
    </Fragment>
  );
}
export default ErrorLoginPage;
